import Vue from 'vue'

const env = {
  apiUrl: process.env.VUE_APP_API_URL,
  appUrl: process.env.VUE_APP_URL
}

Vue.prototype.$env = env

export default env
